import { ChevronRightIcon } from "@chakra-ui/icons";
import { Center, ListItem, Spinner, UnorderedList, useMultiStyleConfig, Text } from "@chakra-ui/react";
import React, { useContext } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { fetchEvents } from "../api/EventsApi";
import { EventContext } from "../App";
import { RegistrationEvent } from "../models/RegistrationEvent";

export const EventsList: React.FunctionComponent<{ organizationId: number | null }> = (props) => {

  const { state, dispatch } = useContext(EventContext);
  const { status, data, error } = useQuery<RegistrationEvent[], Error>(['events', props.organizationId], () => fetchEvents(props.organizationId), { refetchOnMount: "always" });
  const styles = useMultiStyleConfig("EventsList", {});

  if (!props.organizationId) {
    return (
      <Center><Text>Kies eerst een organisatie</Text></Center>
    )
  }

  return (
    <>
      {status === "loading" ? (
        <Center><Spinner></Spinner></Center>
      ) : status === "error" ? (
        <span>Error: {error!.message}</span>
      ) : (
        <>
        <UnorderedList sx={styles.list}>
          {data !== undefined && (data).map((value: RegistrationEvent, index: number) => {
            return <Link to="/event" key={value.id}>
              <ListItem sx={styles.listitem} aria-selected={state.selectedEvent !== null && state.selectedEvent!.id === value.id}
                onClick={() => { dispatch({ type: "SELECT_EVENT", payload: { selectedEvent: value } }) }}>
                {value.name}<ChevronRightIcon boxSize={6} float="right" />
              </ListItem></Link>
          })}
        </UnorderedList>
        </>
      )}
    </>
  )

}